import { Component } from '@angular/core';
import { ProductTypeEnum, RegistrationPageAppDisplayNames } from 'src/app/shared/enum/ProductTypeEnum';
import { BillingCycle, NewOrganizationDto, OrganisationRegistrationDto, RegistrationPageViewModeEnum, SubscriptionPlan, SubscriptionState, UserAddon } from 'src/app/shared/interfaces/ISubscription';
import { ApiUrls } from 'src/app/shared/constants/ApiUrls';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { ScreenSizeService } from 'src/app/shared/services/screen-size.service';
import { Router } from '@angular/router';

enum steps {
  chooseProduct = 1,
  addOrganisation = 2,
  summary = 3,
  // chooseSketch = 3,
  // plans = 4,
  // summary = 5,
}

@Component({
  selector: 'app-new-organisation',
  templateUrl: './new-organisation.component.html',
  styleUrl: './new-organisation.component.scss'
})
export class NewOrganisationComponent {
  organizationDetails: OrganisationRegistrationDto;
  selectedStep = steps.chooseProduct;
  steps = steps;
  subscriptionState: SubscriptionState = {
    selectedApp: ProductTypeEnum.EplanSketch,
    viewMode: RegistrationPageViewModeEnum.single,
    selectedPlans: {
      "1": null,
      "2": null,
      "3": null,
      "4": null,
      "5": null,
      "6": null,
      "7": null,
      "8": null,
      "9": null,
      "10": null,
    },
  };
  availablePlans: SubscriptionPlan[] = []
  selectedPlans: SubscriptionPlan[] = [];
  appNames = RegistrationPageAppDisplayNames;
  selectedCountryCurrency = 'DKK';
  selectedBillingCycle = 'Yearly';
  formSubmissionStatus: 'awaiting' | 'success' | 'failure' = null;
  userSlabs: UserAddon[] = [];
  totalCost: number = 0
  isSummarySidebarHidden = false;
  isPaymentSelected = false;

  constructor(
    private request: DoHttpService,
    private screenSize: ScreenSizeService,
    private router: Router,
  ) { }

  ngOnInit() {
    if (this.isMobile) {
      this.isSummarySidebarHidden = true;
    }
    const url = ApiUrls.getAllSubscriptionPlans;
    this.request.get(url).subscribe({
      next: (res) => {
        this.availablePlans = res
      },
      error: (res) => {
      }
    })
  }

  get isMobile() {
    return this.screenSize.isMobile()
  }

  changeSummaryVisibility() {
    if (this.isMobile) {
      this.isSummarySidebarHidden = !this.isSummarySidebarHidden;
    }
  }

  calculateSummaryGoGorward() {
    this.selectedPlans = [];
    const selectedPlan = Object.entries(this.subscriptionState.selectedPlans)
      .filter(([key, value]) => value !== null)[0];
    const currentlySelectedPlan = this.availablePlans.find(plan => plan.subscriptionTierId === selectedPlan[1]);
    this.selectedPlans.push(currentlySelectedPlan);
    this.calculateTotalUserCount(currentlySelectedPlan);
    this.calculateAddOnCost(currentlySelectedPlan);
    this.recalculateOrderTotal();
    this.selectedStep = this.selectedStep + 1;
  }

  goForward(organizationDetails: OrganisationRegistrationDto) {
    this.updateOrganisationDetails(organizationDetails);
    this.selectedStep = this.selectedStep + 1;
  }

  updateOrganisationDetails(organizationDetails: OrganisationRegistrationDto) {
    this.organizationDetails = organizationDetails;
    this.selectedCountryCurrency = organizationDetails.currency;
  }

  goBack(organizationDetails: OrganisationRegistrationDto) {
    if (organizationDetails) {
      this.updateOrganisationDetails(organizationDetails);
    }
    this.selectedStep = this.selectedStep - 1;
    // if (this.isSketchSelected() && this.selectedStep === steps.) {
    //   this.selectedStep = steps.chooseSketch;
    // } else if (!this.isSketchSelected() && this.selectedStep === steps.plans) {
    //   this.selectedStep = steps.chooseApp;
    // } else {
    //   this.selectedStep = this.selectedStep - 1;
    // }
  }

  // decideNextStep() {
  //   if (this.isSketchSelected()) {
  //     this.selectedStep = steps.chooseSketch;
  //   } else {
  //     this.selectedStep = steps.plans;
  //   }
  // }

  // changeSketchVariant(e) {
  //   this.selectedAppChanged(e.sketchVariantProductType);
  //   this.selectedStep = this.selectedStep + 1;
  // }

  onBillingCycleChanged(e) {
    this.selectedBillingCycle = e;
    this.selectedPlans.forEach(plan => {
      this.calculateTotalUserCount(plan);
      this.calculateAddOnCost(plan);
    });
    this.recalculateOrderTotal();
  }

  calculateTotalUserCount(plan: SubscriptionPlan) {
    plan.totalUserCount = plan.numberOfUsers + plan.addOnCount;
  }

  // selectedAppChanged(app) {
  //   const currentSelectedAppKey = Object.keys(this.subscriptionState.selectedPlans).find(key => 
  //     this.subscriptionState.selectedPlans[key] !== null
  //   );

  //   this.subscriptionState.selectedApp = app;
  //   if(+currentSelectedAppKey!==app){
  //     this.subscriptionState.selectedPlans = {
  //       "1": null,
  //       "2": null,
  //       "3": null,
  //       "4": null,
  //       "5": null,
  //       "6": null,
  //       "7": null,
  //       "8": null,
  //       "9": null,
  //       "10": null,
  //     };
  //   }

  // }

  subscriptionStateChanged(event) {
    this.selectedPlans = [];
    this.subscriptionState = event;
    const selectedPlan = Object.entries(this.subscriptionState.selectedPlans)
      .filter(([key, value]) => value !== null)[0];
    const currentlySelectedPlan = this.availablePlans.find(plan => plan.subscriptionTierId === selectedPlan[1]);
    this.selectedPlans.push(currentlySelectedPlan);
    this.calculateTotalUserCount(currentlySelectedPlan);
    this.calculateAddOnCost(currentlySelectedPlan);
    this.recalculateOrderTotal();
  }

  calculateAddOnCost(plan?: SubscriptionPlan) {
    if (!plan || !(plan.addOnCount > 0)) return;
    let matchedSlab: UserAddon | undefined;
    for (const slab of this.userSlabs) {
      if (slab.productType !== plan.productType) continue;

      if (slab.userRangeTo === null || slab.unlimitedUsers || plan.totalUserCount <= slab.userRangeTo) {
        matchedSlab = slab;
        break;
      }
    }
    if (!matchedSlab) return;
    plan.addOnSlab = matchedSlab;

    const addOnRates = plan.addOnSlab.userSlabRates.find(slabRate => slabRate.currency === this.selectedCountryCurrency);
    const addOnRate = this.selectedBillingCycle === 'Monthly' ? addOnRates.monthlyPrice : addOnRates.yearlyPrice;
    plan.addOnRate = addOnRate;
    plan.addOnCost = plan.addOnCount * addOnRate;
  }

  recalculateOrderTotal() {
    let total = 0;
    for (const plan of this.selectedPlans) {
      let rates = plan.tierRates.find(rate => rate.currency === this.selectedCountryCurrency);
      let rate = this.selectedBillingCycle === 'Monthly' ? rates.monthlyRate : rates.yearlyRate;
      plan.rate = rate;
      total += rate + (plan.addOnCost ?? 0);
    }
    this.totalCost = total;
  }

  savePlanDetails() {
    const subscriptionTierId = Object.values(this.subscriptionState.selectedPlans).find(value => value !== null);
    let newOrganizationDto: NewOrganizationDto = { ...this.organizationDetails, subscriptionTierId: subscriptionTierId, billingCycle: this.selectedBillingCycle === 'Monthly' ? BillingCycle.Monthly : BillingCycle.Annually };
    this.formSubmissionStatus = 'awaiting';

    this.request.post(ApiUrls.createNewOrganisation, newOrganizationDto).subscribe({
      next: (res) => {
        if (res.updatable) {
          this.formSubmissionStatus = 'success';
        } else {
          this.formSubmissionStatus = 'failure';
        }
      },
      error: (err) => {
        this.formSubmissionStatus = 'failure';
        console.error(err);
      }
    })
    // this.selectedStep += 1;
  }

  goToHomePage() {
    this.router.navigate(['/home'])
  }

  isSketchSelected(currentApp = this.subscriptionState.selectedApp) {
    let nonSketch = [1, 2, 3];
    return !nonSketch.includes(currentApp);
  }

}
